import { PawPrint } from 'lucide-react';
import { TrackerCard } from './components/TrackerCard';
import { useTrackerRegistry } from './hooks';

/**
 * Pinned trackers on the digest — the reason the module exists at all.
 *
 * "Has anyone fed the dog?" is a *breakfast* question, and the digest is the breakfast
 * screen, so a pinned tracker is answerable without navigating anywhere. Cards render in
 * `compact` mode so they read as one more digest section rather than a bordered widget
 * dropped into the page.
 *
 * Renders nothing at all when no tracker is pinned: an empty "Trackers" heading on the
 * morning screen would be an advert for a feature, which is precisely the kind of thing
 * the no-demand-mechanics rule keeps off this page.
 */
export function PinnedTrackers(): JSX.Element | null {
  const { trackers } = useTrackerRegistry();
  const pinned = trackers.filter((tracker) => tracker.pinned);

  if (pinned.length === 0) return null;

  return (
    <section className="flex flex-col gap-3" data-testid="digest-trackers">
      <div className="flex items-center gap-2">
        <PawPrint className="h-4 w-4 text-accent" aria-hidden="true" />
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.08em] text-fg-3">
          Keeping an eye on
        </h2>
      </div>
      {pinned.map((tracker) => (
        <TrackerCard key={tracker.id} tracker={tracker} compact />
      ))}
    </section>
  );
}
